// extracted by mini-css-extract-plugin
export default {"checkbox":"x5S34H","checkboxError":"an6GEK"};